import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Deactivate Code Bulk
  [types.DEACTIVATE_CODE_BULK_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.DEACTIVATE_CODE_BULK_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      loading: false
    };

    return { ...data };
  },

  [types.DEACTIVATE_CODE_BULK_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};